// Using an unused Show Pass on a show you're already on (16 Oct 2026). The server
// (functions/lib/show-pass-apply.js) makes the real checks inside a transaction;
// these decide only whether to OFFER the button and what to say back.

// Offer "Use your Show Pass on this show" to anyone on the show (owner,
// administrator or member) who holds an unused pass, while the show has none.
export function canOfferShowPass(user, project) {
    if (!user || !user.uid || !project || !project.id) return false;
    if (!((user.showPasses || 0) > 0)) return false;
    if (project.unlocked || project.isSample || project.issrc) return false;
    return project.ownerUID === user.uid
        || Object.prototype.hasOwnProperty.call(project.collaborators || {}, user.uid);
}

const REFUSALS = {
    'already-has-pass': 'This show already has a Show Pass. Your pass wasn\'t used.',
    'no-pass': 'You don\'t have an unused Show Pass.',
    'not-on-show': 'You\'re not on this show.',
    'no-show': 'This show no longer exists.',
    'not-eligible': 'A Show Pass can\'t be used on this show.'
};
export const APPLY_FAILED = 'The Show Pass could not be applied. Nothing was changed.';

// err is what httpsCallable rejects with; the server puts its reason in details.
export function applyErrorMessage(err) {
    const reason = err && err.details && err.details.reason;
    return REFUSALS[reason] || APPLY_FAILED;
}

export function appliedNotice(title) {
    return `${title || 'This show'} now has a Show Pass. Everyone on it can edit.`;
}

// Project Settings: "Show Pass applied by Jordan Lee on Oct 16, 2026."
export function passAppliedLine(name, appliedAt) {
    const d = appliedAt ? new Date(appliedAt) : null;
    const on = d && !isNaN(d.getTime())
        ? ` on ${d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`
        : '';
    return name ? `Show Pass applied by ${name}${on}.` : `Show Pass applied${on}.`;
}


// WEBPACK FOOTER //
// ./src/lib/show-pass-apply.js